/* eslint-disable react/jsx-curly-brace-presence */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Collapse, NavItem, NavLink } from "reactstrap";

const SubMenu = (props) => {
  const { icon, title, children, isExpanded = false, open = false } = props;
  const [collapsed, setCollapsed] = useState(!open);
  const toggle = () => setCollapsed(!collapsed);

  useEffect(() => {
    if (!isExpanded) setCollapsed(!open);
  }, [open, isExpanded]);

  return (
    <>
      <NavItem onClick={toggle} className={classNames({ "menu-open": !collapsed })}>
        <NavLink href="#" style={{ display: "flex", alignItems: "center" }}>
          <FontAwesomeIcon icon={icon} className={`${isExpanded ? "mr-2" : "mx-auto"}`} size="lg" />
          {isExpanded && title}
          {isExpanded && (
            <div className={`${isExpanded ? "ml-1" : "ml-0"} d-flex align-items-center`}>{!collapsed ? <ChevronUp size={14} /> : <ChevronDown size={14} />}</div>
          )}
        </NavLink>
      </NavItem>
      <Collapse isOpen={!collapsed} navbar className={classNames("items-menu", { "mb-1": !collapsed }, "sidebar-menu", "py-0")}>
        {children}
      </Collapse>
    </>
  );
};

export default SubMenu;
